// extracted by mini-css-extract-plugin
module.exports = {"search-biomarkers-input":"styles_search-biomarkers-input__vMwkW"};